import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {crearHash} from "../Funciones/crearHash";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {registrarMovimiento} from "../Movimientos/registrarMovimiento";
import {adap_deposito_mov} from "../Adaptadores/adap_deposito_mov";

export const crearDepositoDesdeBono = async ({entidad, usuario, desde, valor}) => {



    entidad.fecha = new Date().getTime()
    entidad.idUsuario = usuario.id
    entidad.nombre = usuario.nombre
    entidad.codigoUsuario = usuario.codigo
    entidad.correo = usuario.correo

    let consecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})
    entidad.consecutivo = consecutivo.data


    let img = await subirImagenHostingFile(entidad.img)
    entidad.img = img.data
    entidad.hashString = JSON.stringify(entidad)
    entidad.hash = crearHash({text: entidad.hashString})
    entidad.estado = 'Aceptado' //Aceptado por que pasa
    entidad.realizo = 'Usuario'
    entidad.detalle = `Deposito realizado desde ${desde}`


    let doxTrans = await registrarMovimiento({movimiento: adap_deposito_mov(entidad, valor), estado: 'Aceptado'})
    if (doxTrans) {
        await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: entidad.consecutivo})

        let consecutivoDeposito = await obtenerConsecutivo({col: 'consecutivos', id: 'depositos'})
        entidad.consecutivo = consecutivoDeposito.data
        entidad.idMovimiento = doxTrans


        let dox = await guardarDoc('depositos', entidad)
        if (dox.res) {
            await aumentarConsecutivo({col: 'consecutivos', id: 'depositos', actual: entidad.consecutivo})
            return true
        } else {
            return false
        }

    } else {
        return false
    }
}